module.exports = __webpack_public_path__ + "img/home.480c3281.jpg";